import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { getAnalytics } from 'firebase/analytics';

const firebaseApp = initializeApp({
    apiKey: "AIzaSyCQ4pQZENG02obVQMg-raBwPqLhAtDbgU4",
    authDomain: "total-fitness-id.firebaseapp.com",
    // databaseURL: "https://ncig-tradein-default-rtdb.firebaseio.com",
    projectId: "total-fitness-id",
    storageBucket: "total-fitness-id.firebasestorage.app",
    messagingSenderId: "925114617437",
    appId: "1:925114617437:web:ce37cc48274a9e4e23c7b4",
    measurementId: "G-XKNBVQY3VY"
});

getAnalytics(firebaseApp);

export const db = getFirestore(firebaseApp);
export const auth = getAuth(firebaseApp);
export const storage = getStorage(firebaseApp);
export const fn = getFunctions(firebaseApp);

export default firebaseApp;